import { Routes, Navigate, Route } from "react-router-dom";
import { isEmpty } from "lodash";

import CustomerLayout from "./../../layouts/CustomerLayout/CustomerLayout";
import DashboardCustomer from "../../pages/Customer/DashboardCustomer/DashboardCustomer";
import DashboardCustomerContext from "../../context/CustomerContext/DashboardCustomerContext/DashboardCustomerContext";
import TransactionUserContext from "../../context/UserContext/TransactionUserContext/TransactionUserContext";
import ProfileUser from "./../../pages/User/ProfileUser/ProfileUser";
import ProfileUserContext from "../../context/UserContext/ProfileUserContext/ProfileUserContext";
import TicketsUser from "../../pages/User/TicketsUser/TicketsUser";
import TicketUserContext from "../../context/UserContext/TicketUserContext/TicketUserContext";
import TransactionsUser from "../../pages/User/TransactionsUser/TransactionsUser";
import FlightUserContext from "../../context/UserContext/FlightUserContext/FlightUserContext";
import FlightsUser from "../../pages/User/FlightsUser/FlightsUser";
import HotelsUser from "../../pages/User/HotelsUser/HotelsUser";
import HotelUser from "../../pages/User/HotelUser/HotelUser";
import HotelUserContext from "../../context/UserContext/HotelUserContext/HotelUserContext";
import ReserveHotelUser from "../../pages/User/ReserveHotelUser/ReserveHotelUser";
import PassengersUser from "../../pages/User/PassengersUser/PassengersUser";
import PassengerUserContext from "../../context/UserContext/PassengerUserContext/PassengerUserContext";
import HotelOrdersUser from "../../pages/User/HotelOrdersUser/HotelOrdersUser";
import HotelOrderUserContext from "../../context/UserContext/HotelOrderUserContext/HotelOrderUserContext";
import FlyOrdersUser from "../../pages/User/FlyOrdersUser/FlyOrdersUser";
import FlyOrderUserContext from "../../context/UserContext/FlyOrderUserContext/FlyOrderUserContext";
import NotFoundPage from "../../pages/Page/NotFoundPage/NotFoundPage";
import ServicesUser from "../../pages/User/ServicesUser/ServicesUser";
import ServiceUser from "../../pages/User/ServicesUser/ServiceUser/ServiceUser";
import ServiceUserContext from "../../context/UserContext/ServiceUserContext/ServiceUserContext";
import ReceptionInfoUser from "../../pages/User/ReceptionInfoUser/ReceptionInfoUser";
import ReceptionInfoUserContext from "../../context/UserContext/ReceptionInfoUserContext/ReceptionInfoUserContext";
import ReceptionOrdersUser from "../../pages/User/ReceptionOrdersUser/ReceptionOrdersUser";
import ReceptionOrderUserContext from "../../context/UserContext/ReceptionOrderUserContext/ReceptionOrderUserContext";
import QrCodeCustomer from "../../pages/Customer/QrCodeCustomer/QrCodeCustomer";
import QrCodeCustomerContext from "../../context/CustomerContext/QrCodeCustomerContext/QrCodeCustomerContext";
import NotificationsUser from "./../../pages/User/NotificationsUser/NotificationsUser";
import NotificationUserContext from "../../context/UserContext/NotificationUserContext/NotificationUserContext";
import ShopOrdersUser from "../../pages/User/ShopOrdersUser/ShopOrdersUser";
import ShopOrderUserContext from "../../context/UserContext/ShopOrderUserContext/ShopOrderUserContext";
import { decodeJWT, getCookies } from "../../utils";
import { userRoleItems, categoryItems } from "../../utils/enum";

const CustomerContainer = () => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  const roleName = decodeJWT(accessToken)?.role;

  if (!isLogin || roleName !== userRoleItems[2])
    return <Navigate to="/" replace />;

  return (
    <CustomerLayout>
      <Routes>
        {/* Dashboard */}
        <Route
          index
          element={
            <DashboardCustomerContext>
              <TransactionUserContext>
                <DashboardCustomer />
              </TransactionUserContext>
            </DashboardCustomerContext>
          }
        />

        {/* Services */}
        <Route path="/services" element={<ServicesUser />} />

        {/* Service */}
        {categoryItems.map((_item) => (
          <Route
            path={`/services/${_item}`}
            element={
              <ServiceUserContext type={_item}>
                <ServiceUser type={_item} />
              </ServiceUserContext>
            }
          />
        ))}

        {/* Qr Code */}
        <Route
          path="/qr-code"
          element={
            <QrCodeCustomerContext>
              <QrCodeCustomer />
            </QrCodeCustomerContext>
          }
        />

        {/* Profile */}
        <Route
          path="/profile"
          element={
            <ProfileUserContext>
              <ProfileUser />
            </ProfileUserContext>
          }
        />

        {/* Tickets */}
        <Route
          path="/tickets"
          element={
            <TicketUserContext>
              <TicketsUser />
            </TicketUserContext>
          }
        />

        {/* Transactions */}
        {["/transactions", "/transactions/:user/user"].map((path) => (
          <Route
            key={path}
            path={path}
            element={
              <TransactionUserContext>
                <TransactionsUser />
              </TransactionUserContext>
            }
          />
        ))}

        {/* Flights */}
        <Route
          path="/flights"
          element={
            <FlightUserContext>
              <FlightsUser />
            </FlightUserContext>
          }
        />

        {/* Hotels */}
        <Route
          path="/hotels"
          element={
            <HotelUserContext>
              <HotelsUser />
            </HotelUserContext>
          }
        />

        {/* Hotel */}
        <Route
          path="/hotel/:id"
          element={
            <HotelUserContext>
              <HotelUser />
            </HotelUserContext>
          }
        />

        {/* Reception Info */}
        <Route
          path="/reception-info/:id"
          element={
            <ReceptionInfoUserContext>
              <ReceptionInfoUser />
            </ReceptionInfoUserContext>
          }
        />

        {/* Reserve Hotel */}
        <Route
          path="/reserve/hotel"
          element={
            <HotelUserContext>
              <ReserveHotelUser />
            </HotelUserContext>
          }
        />

        {/* Reception Orders */}
        <Route
          path="/reception-orders"
          element={
            <ReceptionOrderUserContext>
              <ReceptionOrdersUser />
            </ReceptionOrderUserContext>
          }
        />

        {/* Shop Orders */}
        <Route
          path="/shop-orders"
          element={
            <ShopOrderUserContext>
              <ShopOrdersUser />
            </ShopOrderUserContext>
          }
        />

        {/* Passengers */}
        <Route
          path="/passengers"
          element={
            <PassengerUserContext>
              <PassengersUser />
            </PassengerUserContext>
          }
        />

        {/* Hotel Order */}
        <Route
          path="/hotel-orders"
          element={
            <HotelOrderUserContext>
              <HotelOrdersUser />
            </HotelOrderUserContext>
          }
        />

        {/* Fly Orders */}
        {["/fly-orders", "/fly-orders/:user/user"].map((path) => (
          <Route
            path={path}
            element={
              <FlyOrderUserContext>
                <FlyOrdersUser />
              </FlyOrderUserContext>
            }
          />
        ))}

        {/* Notifications */}
        <Route
          path="/notifications"
          element={
            <NotificationUserContext>
              <NotificationsUser />
            </NotificationUserContext>
          }
        />

        {/* Not Found */}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </CustomerLayout>
  );
};

export default CustomerContainer;
